module.exports = __webpack_public_path__ + "img/ssb_menu6.bce4fabd.png";